import Color from 'color'

export const getTextColor = (backgroundColor) => {
  return Color(backgroundColor).light() ? '#000000' : '#ffffff'
}

export const getAppliedFilters = (filterObject) => {
  let appliedFilters = {}

  Object.keys(filterObject).forEach(outerKey => {
    appliedFilters[outerKey] = null
    Object.keys(filterObject[outerKey].values).forEach(innerKey => {
      if (filterObject[outerKey].values[innerKey].value) {
        if (appliedFilters[outerKey] === null) {
          appliedFilters[outerKey] = []
        }
        appliedFilters[outerKey].push(innerKey)
      }
    })
  })
  return appliedFilters
}

export const getRange = (start, end) => {
  return Array.from({length: end - start + 1}, () => start++)
}

export function MixinException (message) {
  this.message = message
  this.name = 'MixinException'
}

export function clearFilters (filterStructure) {
  // Copy the object as the original should not be mutated because it is part of vuex
  const returnObject = Object.assign({}, filterStructure)
  for (let filterKey in returnObject) {
    if (!returnObject.hasOwnProperty(filterKey)) continue
    if (returnObject[filterKey].isList) {
      returnObject[filterKey].values = []
    } else {
      for (let valueKey in returnObject[filterKey].values) {
        if (!returnObject[filterKey].values.hasOwnProperty(valueKey)) continue
        returnObject[filterKey].values[valueKey].value = false
      }
    }
  }
  return returnObject
}

export function filtersApplied (filterStructure) {
  for (let filterKey in filterStructure) {
    if (!filterStructure.hasOwnProperty(filterKey)) continue
    for (let valueKey in filterStructure[filterKey].values) {
      if (!filterStructure[filterKey].values.hasOwnProperty(valueKey)) continue
      if (filterStructure[filterKey].values[valueKey].value) {
        return true
      }
    }
  }
  return false
}

export const alternateRouteName = (route) => {
  switch (route.name) {
    case 'Dashboard': return 'menu_dashboard'
    case 'Students': return 'menu_my_students'
    case 'Interactions': return 'menu_intervention'
    case 'DailyFeeds': return 'menu_feeds'
    case 'TutorIntervention':
    case 'TutorInteractions':
    case 'TutorExemption':
    case 'TutorAlert': return 'student_interaction'
    case 'TutorAttendance': return 'student_attendance'
    case 'StudentHome': return 'menu_student_profile'
    case 'AdminAlerts': return 'admin.alerts.alerts'
    case 'AdminAnnouncements': return 'admin.announcements'
    case 'Help': return 'help.link'
    case 'Insights': return 'menu_insights'
    default: return route.name
  }
}

export const getDataSetDescription = (dataSet) => {
  let identifier = dataSet.dataSetItem.dataSetIdentifier
  let translation = `admin.alerts.new.data_sets.dataSetTitle.${identifier}`

  if (identifier === 'ENGAGEMENT') {
    return {text: translation,
      x: `${dataSet.minThreshold} - ${dataSet.maxThreshold}`,
      y: dataSet.consecutiveDays
    }
  } else if (identifier === 'RESOURCE') {
    return {text: translation,
      x: dataSet.minThreshold,
      y: buildFilterValue(dataSet.dataSetItem.filterValues, dataSet.filterValue),
      z: dataSet.consecutiveDays
    }
  } else if (identifier === 'ATTENDANCE') {
    return {text: translation,
      x: buildThresholdCondition(dataSet),
      y: dataSet.minThreshold,
      z: `and ${dataSet.maxThreshold}`,
      k: `admin.alerts.new.data_sets.thresholdKey.${dataSet.dataSetItem.thresholdKey}`,
      d: dataSet.consecutiveDays
    }
  } else {
    return {text: ''}
  }
}

export const buildThresholdCondition = (dataSet) => {
  if (dataSet.thresholdCondition && dataSet.dataSetItem.thresholdConditions) {
    return dataSet.dataSetItem.thresholdConditions.filter(el => el.value === dataSet.thresholdCondition)[0].text
  }
}

export const buildFilterValue = (values, value) => {
  if (value && value.length > 0) {
    let others = value.length > 2 ? 'others' : 'other'
    let key = values.filter(el => el.value === value[0])[0].text
    if (value.length > 1) {
      return `${key} (+${value.length - 1} ${others})`
    }
    return key
  }
}



// WEBPACK FOOTER //
// ./src/HelperMethods.js